 import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules"; // Autoplay removed
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "../Style/gallerySlider.css";

import dhoop1 from '../assets/image/product/dhoop1.webp'
import dhoop2 from '../assets/image/product/dhoop2.webp'
import dhoop3 from '../assets/image/product/dhoop3.webp'
import dhoop4 from '../assets/image/product/dhoop4.webp'
import dhoop5 from '../assets/image/product/dhoop5.webp'
 import kachha_bella1 from '../assets/image/product/1.webp'
 import Shagun_Premium1 from '../assets/image/product/2.webp'
 import madhuban1 from '../assets/image/product/3.webp'

const images = [

  { img: madhuban1, title: " " },
  
  { img: kachha_bella1, title: " " },
  
  { img: Shagun_Premium1, title: " " },
  { img: dhoop1, title: " " },
  { img: dhoop2, title: " " },
  { img: dhoop3, title: " " },
  { img: dhoop4, title: " " },
  { img: dhoop5, title: " " },
   
  
  
];

const GallerySlider = () => {
  return (
    <section className="gallery-slider-section">
      <h2 className="section-title">Our Premium Products</h2>

      <Swiper
        modules={[Navigation, Pagination]}
        navigation
        pagination={{ clickable: true }}
        loop={true}
        spaceBetween={25}
        slidesPerView={4}
        breakpoints={{
          0: { slidesPerView: 1 },
          600: { slidesPerView: 2 },
          900: { slidesPerView: 3 },
          1200: { slidesPerView: 4 },
        }}
      >
        {images.map((item, idx) => (
          <SwiperSlide key={idx}>
            <div className="product-card">
              <img src={item.img} alt={item.title} className="product-img" />
              <div className="product-info">
                <h3>{item.title}</h3>
                <p>Premium Quality Incense</p>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
};

export default GallerySlider;
